module.exports = __webpack_public_path__ + "img/camion-mobile.14a6fc18.png";